import React, { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Select from '@nmx/template/dist/componentLibrary/components/forms/Select';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// utils
import Session from '@nmx/utils-frontend/dist/utilities/frontend/session';
import { stateOptionsList50States } from '../../../../../utils/stateOptionsList';
// images
import imageSvg from './images/usa-map-dot-mosaic.svg';
// styles
import {
  ColStyled,
  FieldsetStyled,
  LegendStyled,
  PictureStyled,
  SectionContainerStyled,
} from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const isMediumUp = theme.mediumUp();
  const FORM_NAME = 'Standalone LTC Insurance Search by State Form';

  // modifying initial item in global stateOptionsList array
  const modifiedStateOptionsList = [
    {
      ...stateOptionsList50States[0],
      name: 'Select your state',
    },
    ...stateOptionsList50States.slice(1),
  ];

  const [stateValue, setStateValue] = useState('');

  const getUsMap = (thisImageSvg) => {
    return (
      <PictureStyled
        lazyLoad={false}
        src={thisImageSvg}
        altText='A dot mosaic image of the map of the United States'
      />
    );
  };

  // on load
  useEffect(() => {
    // adobe datalayer push
    window.adobeDataLayer.push({
      event: 'form-load',
      form:{
        name : FORM_NAME,
        experience: 'other',
        'form-type': 'simple',
      },
    });
  }, []);

  const analyticsPush = (e) => {
    const { name } = e.target;
    // adobe datalayer push
    window.adobeDataLayer.push({
      event: 'form-interact',
      form: {
        name : FORM_NAME,
        experience: FORM_NAME,
        'form-type': 'simple',
        'action-keys': name,
        'action-values': 'completed',
      },
    });
  };

  const handleChange = (e) => {
    setStateValue(e.target.value);
    Session.set('ltcSearchByStateSelection', e.target.value);

    window.adobeDataLayer.push({
      event: 'form-complete',
      form:{
        name : FORM_NAME,
        experience: 'other',
        'form-type': 'simple',
        'submission-type': 'other',
      },
    });

    window.location.href = '/long-term-care-planning/standalone-long-term-care-insurance/';
  };

  return (
    <SectionContainerStyled
      id='standalone-ltc-insurance-search-by-state-intro'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <ColStyled
          medium={7}
          large={5}>
          <Row align='center'>
            <Col
              xsmall={10}
              small={8}
              medium={12}
              nested>
              <Typography
                component='h1'
                nextElement='typography'
                align={isMediumUp ? 'left' : 'center'}>
                Standalone long&#45;term <WidowBlock>care insurance</WidowBlock>
              </Typography>
            </Col>
          </Row>
          {!isMediumUp && getUsMap(imageSvg)}
          <Typography nextElement='typography'>
            See what&#39;s available where you live.
          </Typography>
          <form
            id='standalone-ltc-insurance-search-by-state-form'
            action='/'>
            <FieldsetStyled>
              <LegendStyled>
                Select a state to see what Standalone Long&#45;term Care Insurance is available near you.
              </LegendStyled>
              <Select
                id='standalone-ltc-insurance-search-by-state-form-select'
                name='standalone-ltc-insurance-search-by-state-form-select'
                labelText='Search by state'
                onBlur={analyticsPush}
                onChange={handleChange}
                value={stateValue}
                options={modifiedStateOptionsList}
                required={false}
              />
            </FieldsetStyled>
          </form>
        </ColStyled>
        {isMediumUp && (
          <Col
            align='center'
            medium={5}
            largeOffset={1}>
            {getUsMap(imageSvg)}
          </Col>
        )}
      </Row>
    </SectionContainerStyled>
  );
};
